export default class AppState {
  submitProtection = false
  loadingData: Array<string> = []
}
